import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const clientIdInterceptor: HttpInterceptorFn = (req, next) => {
  const clientIdRequest = req.clone({
    setHeaders: {
      'x-client-id': environment.clientId
    }
  });

  return next(clientIdRequest);
};
